<template>
    <div>

        <vx-card>

            <vs-table id="table" ref="table" pagination search :data="tableData" :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="status">Status</vs-th>
                    <vs-th sort-key="channel">Channel</vs-th>
                    <vs-th sort-key="provider">Provider</vs-th>
                    <vs-th sort-key="in_template">In template</vs-th>
                    <vs-th sort-key="location_name">Location</vs-th>
                    <vs-th sort-key="checker">Checker enabled</vs-th>
                    <vs-th sort-key="score">Score</vs-th>
                    <vs-th sort-key="enabled">Enabled</vs-th>
                    <vs-th sort-key="stream_format">Format</vs-th>
                    <vs-th sort-key="video_codec">Video Codec</vs-th>
                    <vs-th sort-key="resolution">Resolution</vs-th>
                    <vs-th sort-key="audio_codec">Audio Codec</vs-th>
                    <vs-th sort-key="audio_sample_rate">Audio Sample rate</vs-th>
                    <vs-th/>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].status" style="width: 130px">
                                <vs-chip @click.native="copySourceLink(data[index].url)" style="cursor:pointer;" color="success" v-if="data[index].status === 1"></vs-chip>
                                <vs-chip @click.native="copySourceLink(data[index].url)" style="cursor:pointer;" color="danger" v-if="data[index].status === 0"></vs-chip>
                                <vs-chip class="ml-3" color="success" v-if="data[index].id === markedSource || markedSources.includes(data[index].id)">In use</vs-chip>
                            </vs-td>

                            <vs-td :data="data[index].channel">
                                {{ data[index].channel }}
                            </vs-td>

                            <vs-td :data="data[index].provider">
                                {{ data[index].provider }}
                            </vs-td>

                            <vs-td :data="data[index].in_template">
                                {{ data[index].in_template }}
                            </vs-td>

                            <vs-td :data="data[index].location_name">
                                {{ data[index].location_name }}
                            </vs-td>

                            <vs-td :data="data[index].checker">
                                <vs-chip style="cursor:pointer;" @click.native="disableSourceChecker(data[index].id)" color="success" v-if="data[index].checker === 'Yes'">Yes</vs-chip>
                                <vs-chip style="cursor:pointer;" @click.native="enableSourceChecker(data[index].id)" color="danger" v-if="data[index].checker === 'No'">No</vs-chip>
                            </vs-td>

                            <vs-td :data="data[index].score">
                                {{ data[index].score }}
                            </vs-td>

                            <vs-td :data="data[index].enabled">
                                <vs-chip style="cursor:pointer;" @click.native="disableSource(data[index].id)" color="success" v-if="data[index].enabled === 'Yes'">Yes</vs-chip>
                                <vs-chip style="cursor:pointer;" @click.native="enableSource(data[index].id)" color="danger" v-if="data[index].enabled === 'No'">No</vs-chip>
                            </vs-td>

                            <vs-td :data="data[index].stream_format">
                                {{ data[index].stream_format }}
                            </vs-td>

                            <vs-td :data="data[index].video_codec">
                                {{ data[index].video_codec }}
                            </vs-td>

                            <vs-td :data="data[index].resolution">
                                {{ data[index].resolution }}
                            </vs-td>

                            <vs-td :data="data[index].audio_codec">
                                {{ data[index].audio_codec }}
                            </vs-td>

                            <vs-td :data="data[index].audio_sample_rate">
                                {{ data[index].audio_sample_rate }}
                            </vs-td>

                            <vs-td>
                                <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-eye" color="success" class="md:mb-0 mr-3 mb-1"  @click="$router.push('/source/' + data[index].id)"></vs-button>
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

    </div>
</template>
<script>

    export default {
        props: {
            sourcesURL: {
                type: String,
                required: true
            },
            markedSource: {
                type: Number,
                required: false,
                default: 0
            },
            markedSources: {
                type: Array,
                required: false,
                default: function() {
                    return [0]
                }
            }
        },
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                sources: [],
                addSourcePrompt: false,

                inputTemplates: [],
                providers: [],
                channels: [],

                addObject: {},

                dataLoaded: false

            }
        },
        methods: {
            loadFullData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const additionalDataPromises = this.loadAdditionalData()
                Promise.all(additionalDataPromises).finally(function() {
                    thisIns.loadData()
                })
            },
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(this.sourcesURL)
                loadPromise.then(function(response) {
                    thisIns.sources = response.data
                    thisIns.dataLoaded = true
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            loadAdditionalData() {
                const thisIns = this
                const templatesPromise = this.$http.get('/api/management/v1/template/?type=0')
                templatesPromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const providersPromise = this.$http.get('/api/management/v1/provider/')
                providersPromise.then(function(response) {
                    thisIns.providers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const channelsPromise = this.$http.get('/api/management/v1/channel/')
                channelsPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                return [templatesPromise, providersPromise, channelsPromise]
            },
            reloadSources() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(this.sourcesURL)
                loadPromise.then(function(response) {
                    thisIns.sources = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            enableSource(id) {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/source/' + id + '/enable', {
                    end_time: this.moment().add(100, 'years')
                })
                reqPromise.then(function() {
                    thisIns.$printSuccess('Source enabled')
                    thisIns.reloadSources()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            disableSource(id) {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/source/' + id + '/disable', {
                    end_time: this.moment().add(100, 'years')
                })
                reqPromise.then(function() {
                    thisIns.$printSuccess('Source disabled')
                    thisIns.reloadSources()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            enableSourceChecker(id) {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/source/' + id + '/checker/enable')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Source checker enabled')
                    thisIns.reloadSources()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            disableSourceChecker(id) {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/source/' + id + '/checker/disable')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Source checker disabled')
                    thisIns.reloadSources()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            copySourceLink(url) {
                const thisIns = this
                thisIns.$copyText(url).then(function() {
                    thisIns.$printSuccess('Link copied to clipboard')
                }, function() {
                    alert(url)
                })
            }
        },
        watch: {
            sourcesURL() {
                this.loadData()
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                if (!this.dataLoaded) return []

                const data = []
                for (let i = 0; i < this.sources.length; i++) {
                    data.push({
                        id: this.sources[i].id,
                        channel: this.channelMap[this.sources[i].channel_id].name,
                        provider: this.providerMap[this.sources[i].provider_id].name,
                        in_template: this.templateMap[this.sources[i].in_template.id].name,
                        checker: (this.sources[i].checker_enabled) ? 'Yes' : 'No',
                        score: this.sources[i].score,
                        enabled: (!this.sources[i].disabled) ? 'Yes' : 'No',
                        stream_format: this.sources[i].stream_format,
                        video_codec: this.sources[i].video_codec,
                        resolution: this.sources[i].resolution,
                        audio_codec: this.sources[i].audio_codec,
                        audio_sample_rate: this.sources[i].audio_sample_rate,
                        status: this.sources[i].status,
                        url: this.sources[i].url,
                        location_name: this.sources[i].location_name
                    })
                }

                return data
            },
            providerMap() {
                const providerMap = {}
                for (let i = 0; i < this.providers.length; i++) {
                    providerMap[this.providers[i].id] = this.providers[i]
                }

                return providerMap
            },
            templateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            channelMap() {
                const channelMap = {}
                for (let i = 0; i < this.channels.length; i++) {
                    channelMap[this.channels[i].id] = this.channels[i]
                }

                return channelMap
            }
        },
        mounted() {
            this.isMounted = true
            this.loadFullData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addSourcePrompt) {
                this.addSourcePrompt = false
                next(false)
            } else {
                next()
            }
        }

    }

</script>
